// src/pages/conversations/ConversationListItemCell.js
import React from 'react';
import { Box, Typography, IconButton, Tooltip, Link as MuiLink, Stack } from '@mui/material';
import {
  ChatBubbleOutline as ConversationIcon,
  VisibilityOutlined as QuickPreviewIcon, // Or RateReviewOutlinedIcon
  ArrowForwardIos as ArrowForwardIosIcon // For a subtle cue that it's clickable
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom'; // Keep for explicit link if needed
import { getConversationPreview } from '../../utils/conversationUtils'; // Adjust path as needed

const ConversationListItemCell = ({ conversation, onQuickPreviewClick, listParamsForNavigation }) => {
  const previewText = getConversationPreview(conversation);

  const handleQuickPreview = (e) => {
    e.stopPropagation(); // Prevent row click when clicking quick preview button
    onQuickPreviewClick(conversation);
  };

  // The main link for the text is now part of the overall row click,
  // but we keep it here for semantic correctness and potential styling.
  // The actual navigation is handled by the row's onClick.
  // We stop propagation on the link itself to prevent double handling IF we decide to make the link also navigate.
  // For now, it's just for text styling and tooltip.

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%'}}>
      <ConversationIcon sx={{ fontSize: '1.3rem', color: 'primary.main', flexShrink: 0, ml: 0.5 }} />
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Tooltip title={previewText} placement="top-start" enterDelay={500}>
            <Typography
                variant="body1"
                component="span" // Changed from MuiLink to Typography as row is clickable
                sx={{
                    fontWeight: 500,
                    display: 'block',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: 'text.primary',
                    '&:hover': { // Visual feedback on text hover even if row is main click target
                        color: 'primary.main',
                    }
                }}
            >
                {previewText}
            </Typography>
        </Tooltip>
        {/* Optional: Second line of info, e.g., agent name if not in a separate column */}
        {/* <Typography variant="caption" color="text.secondary" noWrap>
          {conversation.agent_name ? `Agent: ${conversation.agent_name}` : 'No specific agent'}
        </Typography> */}
      </Box>
      <Tooltip title="Quick Preview" placement="top">
        <IconButton
          size="small"
          onClick={handleQuickPreview}
          sx={{ flexShrink: 0, mr: 0.5 }}
          aria-label="Quick preview conversation"
        >
          <QuickPreviewIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      {/* Optional: A subtle visual cue that the row is interactive, can be removed if preferred */}
      {/* <ArrowForwardIosIcon sx={{ fontSize: '0.9rem', color: 'text.disabled', flexShrink: 0 }} /> */}
    </Stack>
  );
};

export default ConversationListItemCell;